import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Breadcrumb } from "react-bootstrap";
import { DateTime } from "luxon";
import { Textfit } from "react-textfit";

import { useAppContext } from "libs/contextLib";
import RealClassList from "components/RealClassList";
import BigSpinner from "components/BigSpinner";
import { navigate, useLocation } from "@reach/router";

import axiosObj from "libs/axios";

import { COURSE_DETAILS_URL } from "constants/urls";

import "./course-class-list.scss";

function CourseClassList(props) {
  const { authenticatedUser } = useAppContext();
  const isLearnDomain = props.domain === "learn";
  const location = useLocation();

  const now = DateTime.local();
  const dateList = Array(6)
    .fill()
    .map((_, i) => now.plus({ days: i }));
  const [selectedDate, setSelectedDate] = useState(dateList[0]);
  const [courseName, setCourseName] = useState("Course");

  useEffect(() => {
    if (!isLearnDomain && authenticatedUser === null) {
      navigate("/login?redirect=" + location.pathname);
    }

    // TODO: Use different APIs for teach and learn - or better - get course name from props
    // TODO: Cancel request when navigating away
    axiosObj.get(COURSE_DETAILS_URL + props.courseId).then(
      (response) => {
        setCourseName(response.data.name);
      },
      (error) => {
        // TODO: Logout on 401
        console.log(error);
      }
    );
  });

  if (!isLearnDomain) {
    if (authenticatedUser === false) {
      return (
        <Container>
          <BigSpinner />
        </Container>
      );
    } else if (authenticatedUser === null) {
      return null;
    }
  }

  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item href={`/${props.domain}`}>Home</Breadcrumb.Item>
        <Breadcrumb.Item active>{courseName}</Breadcrumb.Item>
      </Breadcrumb>
      <Container className="class-list">
        <DateFilterList
          dateList={dateList}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
        <RealClassList
          courseId={props.courseId}
          selectedDate={selectedDate}
          domain={props.domain}
        />
      </Container>
    </>
  );
}

function DateFilterList(props) {
  return (
    <Row className="date-list mt-3 justify-content-around">
      {props.dateList.map((date) => (
        <Col
          key={date.toISODate()}
          xs={4}
          md={2}
          className="date p-0 mb-3 text-center align-self-center "
        >
          <Button
            onClick={() => props.setSelectedDate(date)}
            // className={
            //   "" + date.toISODate() === props.selectedDate.toISODate()
            //     ? "custom-active"
            //     : ""
            // }
          >
            <Textfit mode="single">
              {date
                .setLocale("en-US")
                .toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)
                .slice(0, -6)}
            </Textfit>
          </Button>
        </Col>
      ))}
    </Row>
  );
}

export default CourseClassList;
